require('./_wks-define')('observable');



/*****************
 ** WEBPACK FOOTER
 ** /Users/luca/dev/juta/ironex.it/~/core-js/modules/es7.symbol.observable.js
 ** module id = 342
 ** module chunks = 0
 **/